import axios from "axios";
import { STORAGEKEY } from "../constants";
import qs from "qs";
import { AUTH_URL, URL } from "./url";
export const Bearer = "Bearer ";

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401 || error.response.status === 403) {
      // localStorage.clear();
      //   window.location.assign("/login");
    } else {
      return error;
    }
  }
);

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get: (url) => {
    return axios.get(URL + url);
  },

  post: (url, data) => {
    return axios.post(URL + url, data);
  },

  postWithUrlEncoded: (url, data, config = {}) => {
    const encodedData = qs.stringify({ jsondata: `${JSON.stringify(data)}` });

    return axios({
      method: "post",
      data: encodedData,
      url: URL + url,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      ...config,
    });
  },

  postWithToken: (url, data) => {
    return axios({
      method: "post",
      data: data,
      url: URL + url,
      headers: {
        authorization: Bearer + localStorage.getItem(STORAGEKEY.SESSION_ID),
      },
    });
  },

  getWithParams: (url, params) => {
    return axios({
      method: "get",
      params,
      url: URL + url,
    });
  },

  getWithToken: (url) => {
    return axios({
      method: "get",
      url: URL + url,
      headers: {
        authorization: Bearer + localStorage.getItem(STORAGEKEY.SESSION_ID),
      },
    });
  },

  putWithToken: (url, data) => {
    return axios({
      method: "put",
      data: data,
      url: URL + url,
      headers: {
        authorization: Bearer + localStorage.getItem(STORAGEKEY.SESSION_ID),
      },
    });
  },

  deleteWithToken: (url, params) => {
    return axios({
      method: "delete",
      params,
      url: URL + url,
      headers: {
        authorization: Bearer + localStorage.getItem(STORAGEKEY.SESSION_ID),
      },
    });
  },

  getFromAuthURLWithParams: (url, params) => {
    return axios({
      method: "get",
      params,
      url: AUTH_URL + url,
    });
  },

  getFromAuthURLWithToken: (url) => {
    return axios({
      method: "get",
      url: AUTH_URL + url,
      headers: {
        authorization: Bearer + localStorage.getItem(STORAGEKEY.TOKEN),
      },
    });
  },

  getFromAuthURLWithTokenAndParams: (url, params) => {
    return axios({
      method: "get",
      params,
      url: AUTH_URL + url,
      headers: {
        authorization: Bearer + localStorage.getItem(STORAGEKEY.TOKEN),
      },
    });
  },

  postFromAuthURL: (url, data) => {
    return axios({
      method: "post",
      data,
      url: AUTH_URL + url,
    });
  },

  postFromAuthURLWithCustomHeader: (url, data, headers) => {
    return axios({
      method: "post",
      data,
      url: AUTH_URL + url,
      headers,
    });
  },

  postFromAuthURLWithToken: (url, data) => {
    return axios({
      method: "post",
      data,
      url: AUTH_URL + url,
      headers: {
        authorization: Bearer + localStorage.getItem(STORAGEKEY.TOKEN),
      },
    });
  },

  postFromAuthURLWithTokenAndParams: (url, params) => {
    return axios({
      method: "post",
      params,
      url: AUTH_URL + url,
      headers: {
        authorization: Bearer + localStorage.getItem(STORAGEKEY.TOKEN),
      },
    });
  },
};
